export default __webpack_public_path__ + "static/media/export-icon.113f0a44.svg";